import NavSlot from "@/components/navigation/links";
import { Outlet } from "react-router-dom";
import JobOngoingDedicated from "./dedicated";
import JobOngoingFixed from "./fixed";

export const jobsOngoing = [
  {
    label: "Fixed",
    value: "fixed",
    path: "/reports/jobs/ongoing/fixed",
    element: JobOngoingFixed,
  },
  {
    label: "Dedicated",
    value: "dedicated",
    path: "/reports/jobs/ongoing/dedicated",
    element: JobOngoingDedicated,
  },
];

const OngoingLayout = () => {
  return (
    <div className="flex-1 overflow-auto relative">
      <div className="sticky  w-full bg-white z-10">
        <NavSlot navItems={jobsOngoing} />
      </div>

      <Outlet />
    </div>
  );
};

export default OngoingLayout;
